import { Grid } from '@mui/material';
import React from 'react';
import type { RaterXCoverage } from '../../../../../api/types/rater-x-preset';
import type { PrimeXProductType } from '../../../../../../../../../types';
import type { PrimeXQuoteHandlers } from '../../../../../types';
import {
  AmendatoryCoverageManager,
  AmendatoryCoverages,
  ContextTypes,
} from './manager';
import { useProposedColumn } from '../../../draft/coverageColumns';
import StagedWas from '../../../draft/components/StagedWas';
import { coveragePropsPath } from '../../../draft/stagedFields';

const AmendatoryCoverageLineItemFactory = (
  props: AmendatoryCoverageLineItemFactoryProps
) => {
  // This cell stands in for the limit and inputs columns together, so it has to
  // shrink with them when the Proposed column takes a unit. Hardcoded at 8, a
  // non-standard row came to 3 + 8 + 1 + 1 and wrapped the moment anything
  // staged — and stopped lining up with the header, which already reads its
  // width from `spans`.
  const spans = useProposedColumn();
  const schema = new AmendatoryCoverageManager(
    props.productType,
    props.contextType
  ).amendatoryCoverageSchema;
  const config = schema[props.id as AmendatoryCoverages] ?? null;
  const Component = config?.Component;

  if (!Component) {
    return <Grid item xs={spans.limit + spans.inputs} pl="5rem" />;
  }

  return (
    <Grid item xs={spans.limit + spans.inputs} pl="5rem">
      <Component
        {...props.coverageState}
        setCoverage={props.setCoverage}
        productType={props.productType}
        contextType={props.contextType}
        id={props.id}
      />
      {/* The ROW owns accept and reject — `ControlsColumn` renders the pair for
          `coverageRowPaths`, which contains this coverage's props. What the row
          cannot supply is the committed value, because only this cell knows
          which editor is on screen. Addressed at the coverage rather than a
          field: each amendatory coverage writes its own prop shape. */}
      <StagedWas paths={[coveragePropsPath(props.id)]} />
    </Grid>
  );
};

export default AmendatoryCoverageLineItemFactory;

type AmendatoryCoverageLineItemFactoryProps = {
  id: string;
  coverageState: RaterXCoverage;
  setCoverage: PrimeXQuoteHandlers['setCoverage'];
  productType: PrimeXProductType;
  contextType?: ContextTypes;
};

export type AmendatoryLineItemProps = {
  id: string;
  setCoverage: PrimeXQuoteHandlers['setCoverage'];
  productType: PrimeXProductType;
  contextType?: ContextTypes;
} & RaterXCoverage;
